<template>
    <button class="actionButton" @click="doClick">
        <div class="mark">
            <IconBase><IconLog /></IconBase>
        </div>
        <div class="txt">履歴</div>
    </button>
</template>

<script>
import MopButtonMixin from "@/components/buttons/MopButtonMixin.vue";
import IconLog from "@/components/icons/IconLog.vue";

export default {
    name: "MopLogButton",
    mixins: [MopButtonMixin],
    components: {
        IconLog
    }
};
</script>
